<template>
	<div class="statistics-structure-select">
		<button
			type="button"
			class="structure-select-trigger"
			@click="$emit('toggle')"
		>
			<span>{{ selectedCustomer ? selectedCustomer.name : $t('statistics.select_location') }}</span>
			<i class="fas fa-caret-down" :class="{ open }"></i>
		</button>

		<div v-if="open" class="structure-select-menu">
			<input
				ref="searchInput"
				class="input structure-search-input"
				type="text"
				:value="search"
				:placeholder="$t('statistics.search_location')"
				@input="$emit('update:search', $event.target.value)"
			/>

			<ui-progress v-if="loading" />

			<div v-else class="structure-options">
				<div
					v-for="item in options"
					:key="item.id"
					class="structure-option"
					:class="{ selected: selectedCustomer && selectedCustomer.id === item.id }"
					:style="{ paddingLeft: `${12 + item.level * 22}px` }"
					@click="$emit('option-click', item)"
				>
					<span class="structure-option-name" @click.stop="$emit('select', item)">{{ item.name }}</span>
					<i
						v-if="item.children.length"
						class="fas structure-option-icon"
						:class="isExpanded(item.id) ? 'fa-angle-up' : 'fa-angle-right'"
						@click.stop="$emit('toggle-node', item.id)"
					></i>
				</div>

				<div v-if="!options.length" class="structure-empty">
					{{ $t('statistics.no_matches') }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'StatisticsStructureSelect',

	props: {
		isExpanded: {
			type: Function,
			required: true
		},
		loading: {
			type: Boolean,
			default: false
		},
		open: {
			type: Boolean,
			default: false
		},
		options: {
			type: Array,
			default: () => []
		},
		search: {
			type: String,
			default: ''
		},
		selectedCustomer: {
			type: Object,
			default: null
		}
	},

	methods: {
		focusSearch() {
			this.$refs.searchInput?.focus();
		}
	}
};
</script>
